import { User } from "@/entities/user";
import { create } from "zustand";


interface AuthState {
  isAuthorized: boolean;
  user: User | null;
  setUser: (user: User) => void;
  setIsAuthorization: () => void;
  logout: () => void;
  isAdmin: boolean;
}

export const useAuthStore = create<AuthState>((set) => ({
  isAuthorized: !!localStorage.getItem("token"),
  user: null,
  isAdmin: false,

    setUser: (user) =>
    set({
      user,
      isAdmin: user.roles?.includes("ADMIN") ?? false,
      isAuthorized: true
    }),

  setIsAuthorization: () => set({ isAuthorized: true }),

  logout: () => {
    localStorage.removeItem("token");
    set({ isAuthorized: false, user: null, isAdmin: false });
  },
}));
